{
    "ConsidermovedtounresolvedasoverflowedLabel": "Beschouw oproepen die naar onopgeloste apparaten zijn verplaatst als overlopend:",
    "StatisticCalculations_SectionHeader": "Statistische berekeningen",
    "StatisticCalculations_SectionPara": "Je kunt kiezen of gesprekken als overgelopen of verlaten worden beschouwd wanneer de applicatie de modellering bewust beëindigt voor gesprekken die naar niet-bewaakte of onbekende apparaatlocaties worden verplaatst.",
    "NAME": "StatisticCalculations"
}